import React, { useEffect, useState } from "react";
import TableDemo from "components/TableDemo";
import OrdersColumn from "data/OrdersColumn";
import OrderFilter from "./components/orderFilter";
import { useSearchParams } from "react-router-dom";
import { quotationApi } from "api/quotations";

// const header
const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status") || "";
  const orderId = searchParams.get("orderId") || "";

  const fetchData = async () => {
    try {
      const params = new URLSearchParams();
      if (status) params.append("status", status);
      if (orderId) params.append("orderNumber", orderId);
      const res = await quotationApi.listContractorAdmin(
        Object.fromEntries(params.entries())
      );

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [status, orderId]);
  return (
    <section className="mt-3">
      <TableDemo
        data={data?.data}
        columns={OrdersColumn(fetchData)}
        title="الطلبات"
        totalCount={data?.pagination?.totalDocs}
        loading={loading}
        extraComponent={<OrderFilter />}
      />
    </section>
  );
};

export default Index;
